import SwapVertIcon from "@mui/icons-material/SwapVert";
import IconButton from "@mui/material/IconButton";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { getImageUploadMode, ImageUploadMode } from "../../../../../utils/validation/videoValidation";
import { useVideo } from "../../../../../context/juno/VideoContext";
import { ColumnBox, RowCenteredBox } from "../../../../../utils/styledBox";
import AspectRatioIcons from "../AspectRatioIcons";
import ImageUpload from "../ImageUpload";
import ModelVersionSelectBox from "../ModelVersionSelectBox";

const ParamsRunway = () => {
  const { t } = useTranslation();
  const { menu, updateParams, image1, setImage1, image2, setImage2, duration, modelVersion, aspectRatios } = useVideo();

  // モデルバージョンに基づいてアスペクト比オプションを取得
  const getAspectRatios = (): string[] => {
    if (modelVersion.RUNWAY === "GEN4_TURBO") {
      return ["1:1", "16:9", "4:3", "9:16", "3:4"];
    } else {
      // GEN3_ALPHA_TURBOの場合
      return ["16:9", "9:16"];
    }
  };

  const aspectRatio = getAspectRatios();

  const durationMarks = [
    {
      value: 5,
      label: "5s",
    },
    {
      value: 10,
      label: "10s",
    },
  ];

  const replaceImage = () => {
    const tmp = image1;
    setImage1(image2);
    setImage2(tmp);
  };

  return (
    <ColumnBox sx={{ gap: 4 }}>
      <ColumnBox>
        {/* Model */}
        <Typography variant="body2" mb={1}>
          {t("juno.video.ai.model")}
        </Typography>
        <ModelVersionSelectBox
          onChange={(value) => {
            // モデルバージョンを更新
            updateParams("RUNWAY", "modelVersion", value);

            // Gen4 -> Gen3への切り替え時にアスペクト比が対応していない場合はデフォルトに変更
            if (value === "GEN3_ALPHA_TURBO") {
              // Gen3でサポートされていないアスペクト比の場合はデフォルト(16:9)に設定
              if (!["16:9", "9:16"].includes(aspectRatios.RUNWAY)) {
                updateParams("RUNWAY", "aspectRatio", "16:9");
              }
            }
          }}
        />
      </ColumnBox>
      <ColumnBox>
        {/* Duration */}
        <Typography variant="body2" mb={1}>
          {t("juno.video.params.duration")}
        </Typography>
        <Slider
          aria-label="duration"
          marks={durationMarks}
          min={5}
          max={10}
          step={5}
          value={duration.RUNWAY}
          onChange={(_, value) => updateParams("RUNWAY", "duration", value)}
        />
      </ColumnBox>

      {menu === "i2v" &&
        (() => {
          const uploadMode = getImageUploadMode("RUNWAY", modelVersion.RUNWAY, menu);
          switch (uploadMode) {
            case ImageUploadMode.DUAL:
              return (
                <ColumnBox sx={{ justifyContent: "center" }}>
                  <Typography variant="body2" mb={1}>
                    {t("juno.video.params.upload")} - FIRST
                  </Typography>
                  <ImageUpload image={image1} setImage={setImage1} />
                  <RowCenteredBox sx={{ my: 2 }}>
                    <IconButton onClick={replaceImage}>
                      <SwapVertIcon />
                    </IconButton>
                  </RowCenteredBox>
                  <Typography variant="body2" mb={1}>
                    {t("juno.video.params.upload")} - LAST
                  </Typography>
                  <ImageUpload image={image2} setImage={setImage2} />
                </ColumnBox>
              );
            case ImageUploadMode.SINGLE:
              return (
                <ColumnBox sx={{ justifyContent: "center" }}>
                  <Typography variant="body2" mb={1}>
                    {t("juno.video.params.upload")}
                  </Typography>
                  <ImageUpload image={image1} setImage={setImage1} />
                </ColumnBox>
              );
            default:
              return null;
          }
        })()}

      <ColumnBox>
        {/* aspect */}
        <AspectRatioIcons aspectRatioList={aspectRatio} />
      </ColumnBox>
    </ColumnBox>
  );
};
export default ParamsRunway;
